import { defineNuxtPlugin } from '#app/nuxt'
import { LazyRokkaImage, LazyNuxtPageDependency, LazyRenderCacheable, LazyVuepalLocalTasks, LazyVuepalAdminToolbar, LazyVuepalRemoteVideo, LazyVuepalLink, LazyVuepalTransitionHeight, LazySpriteSymbol, LazyBlokkliField, LazyBlokkliEditable, LazyBlokkliProvider, LazyBlokkliItem } from '#components'
const lazyGlobalComponents = [
  ["RokkaImage", LazyRokkaImage],
["NuxtPageDependency", LazyNuxtPageDependency],
["RenderCacheable", LazyRenderCacheable],
["VuepalLocalTasks", LazyVuepalLocalTasks],
["VuepalAdminToolbar", LazyVuepalAdminToolbar],
["VuepalRemoteVideo", LazyVuepalRemoteVideo],
["VuepalLink", LazyVuepalLink],
["VuepalTransitionHeight", LazyVuepalTransitionHeight],
["SpriteSymbol", LazySpriteSymbol],
["BlokkliField", LazyBlokkliField],
["BlokkliEditable", LazyBlokkliEditable],
["BlokkliProvider", LazyBlokkliProvider],
["BlokkliItem", LazyBlokkliItem],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
